var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var AlwaysTrueFn = function () { return true; };
export var AlwaysFalseFn = function () { return false; };
export var always = function (a) { return function () { return a; }; };
export var cond = function (items) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var _a = 0, items_1 = items; _a < items_1.length; _a++) {
        var i = items_1[_a];
        if (i[0].apply(i, args))
            return i[1].apply(i, args);
    }
}; };
export var eqBy = function (fn, a, b) {
    if (fn === void 0) { fn = function (v) { return v; }; }
    return fn(a) === fn(b);
};
export var eqByFn = function (fn) { return function (a, b) { return eqBy(fn, a, b); }; };
export var first = function (arr) { return arr && arr.length > 0 ? arr[0] : undefined; };
export var last = function (arr) { return arr ? arr[arr.length - 1] : undefined; };
export var lastInString = function (arr) { return arr ? arr[arr.length - 1] : undefined; };
export var take = function (num, arr) { return arr.slice(0, num); };
export var sum = function (numbers) { return numbers.reduce(function (a, b) { return a + b; }, 0); };
export var mean = function (numbers) { return sum(numbers) / numbers.length; };
export var median = function (arr) {
    var mid = Math.floor(arr.length / 2), nums = __spreadArray([], arr).sort(function (a, b) { return a - b; });
    return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
export function isNil(v) {
    return v === null || v === undefined;
}
export var dissoc = function (key, obj) {
    var newObj = {};
    for (var k in obj) {
        if (k !== key)
            newObj[k] = obj[k];
    }
    return newObj;
};
export var omit = function (arr) {
    var elementsToOmit = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        elementsToOmit[_i - 1] = arguments[_i];
    }
    return arr.filter(function (a) { return !elementsToOmit.includes(a); });
};
export var both = function (a, b) { return a() && b(); };
export var bothFn = function (a, b) { return function () { return a() && b(); }; };
export var prop = function (key, object) { return object[key]; };
export var propFn = function (key) { return function (object) { return prop(key, object); }; };
export var groupBy = function (fn, array) {
    var result = {};
    array.forEach(function (o) {
        var key = fn(o) + '';
        if (!result[key])
            result[key] = [];
        result[key].push(o);
    });
    return result;
};
export var allPass = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return fns.every(function (f) { return f(); });
};
export var allPassFn = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function () { return fns.every(function (f) { return f(); }); };
};
export var uniq = function (arr) { return Array.from(new Set(arr)); };
export var uniqById = function (arr) { return Array.from(new Set(arr.map(function (a) { return a.id; }))).map(function (id) { return arr.find(function (a) { return a.id === id; }); }); };
export var findLast = function (fn, array) { return __spreadArray([], array).reverse().find(fn); };
export var pick = function (keys, object) {
    var result = {};
    var keysConst = __spreadArray([], keys);
    keysConst.forEach(function (k) { return result[k] = object[k]; });
    return result;
};
export var merge = function (a, b, c) {
    return __assign(__assign(__assign({}, a), b), c);
};
export var mergeLeft = function (a, b) {
    return __assign(__assign({}, b), a);
};
export var mergeRight = merge;
export var mapObject = function (transformer, object) {
    var result = {};
    Object.entries(object).forEach(function (e) { return result[e[0]] = transformer(e[1]); });
    return result;
};
export var intersection = function (A, B) { return A.filter(function (a) { return B.includes(a); }); };
export var difference = function (A, B) { return A.filter(function (a) { return !B.includes(a); }); };
export var symmetricDifference = function (A, B) { return __spreadArray(__spreadArray([], difference(A, B)), difference(B, A)); };
export var defaultComparator = function (a, b) { return a === b; };
export var idComparator = function (a, b) { return a.id === b.id; };
export var intersectionBy = function (comparator, A, B) {
    if (comparator === void 0) { comparator = defaultComparator; }
    return A.filter(function (a) { return B.find(function (b) { return comparator(a, b); }); });
};
export var differenceBy = function (comparator, A, B) {
    if (comparator === void 0) { comparator = defaultComparator; }
    return A.filter(function (a) { return !B.find(function (b) { return comparator(a, b); }); });
};
export var symmetricDifferenceBy = function (comparator, A, B) {
    if (comparator === void 0) { comparator = defaultComparator; }
    return __spreadArray(__spreadArray([], differenceBy(comparator, A, B)), differenceBy(comparator, B, A));
};
